import Grid from '@material-ui/core/Grid'
import React from 'react'
import { useStyles } from '../pages/styled'
import theme from '../theme'
import { BackButton } from './BackButton'

type BackButtonLayoutProps = {
  text: string
  onClick?: () => void
}

const BackButtonLayout = ({
  text,
  onClick = () => null,
}: BackButtonLayoutProps) => {
  const classes = useStyles(theme)
  return (
    <Grid item xs={12} sm={12} xl={12} className={classes.gridCenter}>
      <BackButton onClick={onClick}>{text}</BackButton>
    </Grid>
  )
}

export default BackButtonLayout
